import Navbar from "./Navbar";
import Footer from "./Footer";
import AnthemMiniPlayer from "./AnthemMiniPlayer";
import useTheme from "../hooks/useTheme";

export function FCLayout({ children }) {
  useTheme("fc");
  return (
    <div className="min-h-screen bg-fc-bg text-fc-ink flex flex-col" data-testid="fc-layout">
      <Navbar variant="fc" />
      <main className="flex-1">{children}</main>
      <Footer variant="fc" />
    </div>
  );
}

export function AnthemLayout({ children }) {
  useTheme("anthem");
  return (
    <div className="min-h-screen bg-an-bg text-an-ink flex flex-col grain" data-testid="anthem-layout">
      <Navbar variant="anthem" />
      <main className="flex-1 relative z-10">{children}</main>
      <Footer variant="anthem" />
      <AnthemMiniPlayer />
    </div>
  );
}
